import React, { Component } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';


class NavLink extends Component {
  render() {
    const classes = classNames('nav-link', this.props.className);

    return (
      <Link {...this.props} className={classes} activeClassName="active" />
    );
  }
}

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/navigation/NavLink/NavLink.js